import CtaSidebarDownload from '@/components/_blog-updates/CtaSidebarDownload';
import { CraftCtaSidebarDownloadProps } from './CraftCtaSidebarDownload.types';
import { mapBlockToCtaSidebarDownloadProps } from './CraftCtaSidebarDownload.utils';

const CraftCtaSidebarDownload = ({ block }: CraftCtaSidebarDownloadProps) => {
  const props = mapBlockToCtaSidebarDownloadProps(block);

  return <CtaSidebarDownload {...props} />;
};

export default CraftCtaSidebarDownload;
